var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadicondark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18.7959H19.5",
    stroke: "white",
    strokeWidth: 2.375,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 1.20508C11.6875 0.54924 11.1558 0.0175781 10.5 0.0175781C9.84416 0.0175781 9.3125 0.54924 9.3125 1.20508H11.6875ZM9.66031 15.1357C10.1241 15.5994 10.8759 15.5994 11.3397 15.1357L18.8969 7.57847C19.3606 7.11473 19.3606 6.36284 18.8969 5.8991C18.4331 5.43535 17.6813 5.43535 17.2175 5.8991L10.5 12.6166L3.78249 5.8991C3.31874 5.43535 2.56685 5.43535 2.10311 5.8991C1.63936 6.36284 1.63936 7.11473 2.10311 7.57847L9.66031 15.1357ZM9.3125 1.20508V14.296H11.6875V1.20508H9.3125Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadicondark);
export default __webpack_public_path__ + "static/media/downloadicondark.e1a0e55c723cfb978f5f7c0ad77d1366.svg";
export { ForwardRef as ReactComponent };